import React from "react";
import { FileText } from "lucide-react";

function CommitteesPDF() {
  const committees = [
    "Institution Innovation Council.pdf",
    "Training and Placement Committee.pdf",
    "Media Cell Committee.pdf",
    "IQSC Team.pdf",
    "Alumni Committee.pdf",
    "Student Counselor Committee.pdf",
    "Grievance Redressal Committee.pdf",
    "Internal Committee.pdf",
    "Industry Interaction Committee.pdf",
    "Anti-Ragging Committee.pdf",
    "SC-ST Committee.pdf",
  ];

  return (
    <div className="bg-[#0b0f1a] text-white py-12 px-5 min-h-screen" style={{
      marginTop:"30px"
    }}>

      {/* Header */}
      <div className="section-title">
        <h2>Sri Chaitanya Polytechnic</h2>
        <p>Committees</p>
      </div>

      {/* List */}
      <div className="max-w-3xl mx-auto space-y-4" style={{
        marginBottom:"20px"
      }}>

        {committees.map((file, index) => (
          <a
            key={index}
            href={`/pdfs/${file}`}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-between 
            bg-[#111827] rounded-xl px-5
            transition-all duration-300 
            hover:shadow-[0_0_15px_rgba(250,204,21,0.25)]"
            style={{
              marginTop:"20px"
            }}
            
          >
            {/* Left */}
            <div className="flex items-center gap-3">
              <FileText className="text-yellow-400" size={20} />
              <span className="font-medium hover:text-yellow-400 transition">
                {file.replace(".pdf", "")}
              </span>
            </div>

            {/* Right */}
            <span className="text-yellow-400 text-sm">
              View PDF
            </span>
          </a>
        ))}

      </div>
    </div>
  );
}

export default CommitteesPDF;